import { postRequest } from 'utils/requests';
import { getAxiosErrorMessage } from 'utils/errors';
import { ChildWorkspace } from '../parts/SelectChildrenStep';

const ENDPOINT = '/customer/children';

interface RawChildAccount {
  customerId: string;
  companyName: string;
  status?: string;
  isTerminated?: boolean;
  childs?: RawChildAccount[];
}

interface ChildrenResponseBody {
  tableData?: RawChildAccount[];
}

interface ChildrenResponse {
  body?: ChildrenResponseBody;
}

export type FetchMspParentChildrenResult =
  | { ok: true; data: readonly ChildWorkspace[] }
  | { ok: false; message: string };

const flattenDirectChildren = (
  rows: readonly RawChildAccount[],
  parentCustomerId: string
): RawChildAccount[] =>
  rows.flatMap(row =>
    row.customerId === parentCustomerId ? row.childs ?? [] : [row]
  );

const toChildWorkspace = (row: RawChildAccount): ChildWorkspace => ({
  id: row.customerId,
  name: row.companyName,
  cancelled: row.status === 'Cancelled' || Boolean(row.isTerminated)
});

export const fetchMspParentChildren = async (
  customerId: string
): Promise<FetchMspParentChildrenResult> => {
  try {
    const res: ChildrenResponse = await postRequest(ENDPOINT, { customerId });
    const rows = res?.body?.tableData ?? [];
    const data = flattenDirectChildren(rows, customerId).map(toChildWorkspace);
    return { ok: true, data };
  } catch (err) {
    return { ok: false, message: getAxiosErrorMessage(err) };
  }
};
